export default ["$log", "$state", "$stateParams", "UserService", "MenuService", "toastr", "LocaleService", function ErrorController($log, $state, $stateParams, UserService, MenuService, toastr, LocaleService) {

    var $scope = this;
    var preErrorTag = "errorPage.";

    function init() {
        var key = $stateParams.key || "offline";
        $scope.error = {
            title: $stateParams.title || LocaleService.get(preErrorTag + key + ".title"),
            description: $stateParams.message || LocaleService.get(preErrorTag + key + ".message")
        };
    }

    init();
}];



// WEBPACK FOOTER //
// ./src/ui/app/error/ErrorPageController.js